const SHOW_PREVIOUS_EVENTS = 'SHOW_PREVIOUS_EVENTS';
const CHANGE_DEVICE_TYPE = 'CHANGE_DEVICE_TYPE';

export default {
    SHOW_PREVIOUS_EVENTS,
    CHANGE_DEVICE_TYPE,
};
